// @ts-nocheck
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import PhotoCameraOutlinedIcon from '@mui/icons-material/PhotoCameraOutlined';
import React, { useRef } from 'react';
import { Grid, FormNav, FormSection, Input, Textarea } from '../FormField';
import './PersonalTab.css';

export default function PersonalTab({ data, onChange, onNext }) {
  const upd = (key) => (val) => onChange({ ...data, [key]: val });
  const fileRef = useRef();

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => onChange({ ...data, photo: ev.target.result });
    reader.readAsDataURL(file);
  };

  const removePhoto = () => {
    onChange({ ...data, photo: null });
    if (fileRef.current) fileRef.current.value = '';
  };

  return (
    <div>
      <FormSection title="Profile Photo">
        <div className="photo-uploader">
          <div className="photo-preview">
            {data.photo ? (
              <img src={data.photo} alt="Profile" className="photo-img" />
            ) : (
              <div className="photo-placeholder">
                <span className="photo-placeholder-icon"><PersonOutlineOutlinedIcon fontSize="inherit" /></span>
                <span className="photo-placeholder-text">No photo</span>
              </div>
            )}
          </div>
          <div className="photo-controls">
            <input
              ref={fileRef}
              type="file"
              accept="image/png, image/jpeg, image/webp"
              onChange={handlePhotoChange}
              style={{ display: 'none' }}
              id="photo-upload"
            />
            <label htmlFor="photo-upload" className="photo-upload-btn">
              <PhotoCameraOutlinedIcon fontSize="inherit" /> {data.photo ? 'Change Photo' : 'Upload Photo'}
            </label>
            {data.photo && (
              <button className="photo-remove-btn" onClick={removePhoto}>
                <DeleteOutlineOutlinedIcon fontSize="inherit" /> Remove
              </button>
            )}
            <div className="photo-hint">
              JPG, PNG or WEBP - Square crop works best
            </div>
          </div>
        </div>
      </FormSection>

      <FormSection title="Contact Information">
        <Input
          label="Full Name"
          required
          value={data.name}
          onChange={upd('name')}
          placeholder="Arjun Sharma"
        />
        <Grid cols={2}>
          <Input
            label="Email"
            required
            type="email"
            value={data.email}
            onChange={upd('email')}
            placeholder="arjun.sharma@email.com"
          />
          <Input
            label="Phone"
            value={data.phone}
            onChange={upd('phone')}
            placeholder="+91 9876543210"
          />
        </Grid>
        <Grid cols={2}>
          <Input
            label="Location"
            hint="City, State is fine"
            value={data.location}
            onChange={upd('location')}
            placeholder="Hyderabad, Telangana"
          />
          <Input
            label="Portfolio Website"
            value={data.portfolio}
            onChange={upd('portfolio')}
            placeholder="arjunsharma.dev"
          />
        </Grid>
        <Grid cols={2}>
          <Input
            label="LinkedIn"
            value={data.linkedin}
            onChange={upd('linkedin')}
            placeholder="linkedin.com/in/arjunsharma"
          />
          <Input
            label="GitHub"
            value={data.github}
            onChange={upd('github')}
            placeholder="github.com/arjunsharma"
          />
        </Grid>
      </FormSection>

      <FormSection title="Professional Summary">
        <Textarea
          label="Summary"
          hint="2-4 sentences with relevant keywords"
          value={data.summary}
          onChange={upd('summary')}
          placeholder="Final year B.Tech Computer Science student at IIT Hyderabad with hands-on experience in full-stack development, machine learning, and cloud infrastructure. Proficient in Python, React, and AWS. Built scalable tools used by 10,000+ users during internship at Razorpay."
          rows={5}
        />
      </FormSection>

      <FormNav showBack={false} showNext onNext={onNext} nextLabel="Next: Education →" />
    </div>
  );
}

